import { createAction } from '@reduxjs/toolkit';
import { BREAKPOINT_SET } from './constants';

export const setBreakpoint = createAction(BREAKPOINT_SET);
